import React from 'react';
import { Box } from '@mui/material';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh' 
    }}>
      <PublicHeader />
      
      <Box sx={{ 
        flexGrow: 1, 
        width: '100%', 
        maxWidth: 1200, 
        mx: 'auto', 
        px: 2 
      }}>
        {children}
      </Box>
      
      <PublicFooter />
    </Box>
  );
};

export default PublicLayout; 